module.exports = __webpack_public_path__ + "img/screen-write-dark-en.0032c870.png";